export enum GENERATING_ERRORS {
  UNSAFE_PROMPT = 'UNSAFE_PROMPT',
  PROMPT_TOO_LONG = 'PROMPT_TOO_LONG',
  TRY_AGAIN_LATER = 'TRY_AGAIN_LATER',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  NOT_ENOUGH_CREDITS = 'NOT_ENOUGH_CREDITS',
  MAX_CUSTOM_PROMPT_STYLES_LIMIT_REACHED = 'MAX_CUSTOM_PROMPT_STYLES_LIMIT_REACHED',
  USER_NOT_CONFIRMED = 'USER_NOT_CONFIRMED',
}

export const GENERATING_ERROR_MESSAGES: Partial<
  Record<GENERATING_ERRORS, string>
> = {
  [GENERATING_ERRORS.PROMPT_TOO_LONG]:
    'Your prompt exceeds the allowed length. Try shortening it.',
};
